<template>
  <div class="homslider-cls">
    <div
      class="home-slider-main myhome-slider"
      v-if="banners && banners.length > 0"
    >
      <div id="testimonial-slider" class="owlcarousel">
        <VueSlickCarousel v-bind="settings">
          <div
            v-for="(banner, index) in banners"
            :key="index"
            class="vue-slide-carousel"
          >
            <!-- <router-link :to="{name:'vendor', params:{delivery_type:(isPickupDelivery == '1'?'delivery':isPickupDelivery == '0'?'takeaway':isPickupDelivery == '2'?'reservation':''),restaurant_name: banner.restaurant_info.slug}}"> -->
            <router-link
              :to="{
                name: 'restaurant-details',
                params: { restaurantId: encodeId(banner.restaurant_id) },
              }"
              v-if="$route.name != 'reservation'"
            >
              <div class="testimonial-item equal-height style-6 4897">
                <img :src="banner.image" />
              </div>
            </router-link>

            <div class="testimonial-item equal-height style-6 4897" v-else>
              <img :src="banner.image" />
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HomeNavBar from "@/components/HomeNavBar.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  props: ["restaurant_id", "locationData"],
  components: { HomeNavBar, VueSlickCarousel },
  data() {
    return {
      loading: true,
      banners: [],
      is_scrren_hide: window.screen.width < 1280 ? true : false,
      settings: {
        focusOnSelect: true,
        touchThreshold: 5,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        // "initialSlide": 0,
        // "centerMode": false,
        // "centerPadding":'40px',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  computed: {
    // ...mapGetters("order", ["isPickupDelivery"]),
  },
  mounted() {
    if (this.$route.name == "Home") {
      this.getBanner();
    } else if (this.$route.name == "reservation") {
      // getBannersDineList
      this.getBannerDinein();
    }
  },

  watch: {
    latitude: function () {
      setTimeout(() => {
        if (this.getBanner()) {
        }
      }, 2000);
    },
    is_pickup_delivery: function () {
      setTimeout(() => {
        if (this.getBanner()) {
        }
      }, 2000);
    },
  },

  methods: {
    ...mapActions("restaurant", ["getNearestBannerList", "getBannersDineList"]),
    encodeId(id) {
      return btoa(id);
    },
    isHomeDeliverySet(value) {
      this.$emit("isDeliveryHome", value);
      this.$store.commit("order/pickupdelivery", value);
    },

    onMobileLocationClick(value) {
      this.$emit("getMobileLatLong", value);
    },

    getBanner() {
      let isGetRestaurant = true;
      this.loading = true;
      if (this.$auth.setting && this.restaurant_id != "") {
        this.banners = [];
        return this.getNearestBannerList({
          vendor_id: this.$auth.getVendorId(),
          is_langauge: this.$store.state.lang.locale,
          restaurant_id: this.restaurant_id,
        }).then((data) => {
          if (data.code == 200) {
            this.banners = data.Result;
            isGetRestaurant = true;
            this.$emit("getRestaurantData", isGetRestaurant);
          } else if (data.code == 101) {
            isGetRestaurant = false;
            this.banners = [];
            this.loading = false;
            this.$emit("getRestaurantData", isGetRestaurant);
          } else {
            this.$emit("getRestaurantData", false);
            this.banners = [];
            this.loading = false;
          }
        });
      }
    },

    getBannerDinein() {
      let isGetRestaurant = true;
      this.loading = true;
      if (
        this.$auth.setting &&
        this.locationData &&
        this.locationData.lat != ""
      ) {
        this.banners = [];
        return this.getBannersDineList({
          vendor_id: this.$auth.getVendorId(),
          is_langauge: this.$store.state.lang.locale,
          latitude: this.locationData.lat,
          longitude: this.locationData.lng,
        }).then((data) => {
          if (data.code == 200) {
            this.banners = data.Result;
            isGetRestaurant = true;
            this.$emit("getRestaurantData", isGetRestaurant);
          } else if (data.code == 101) {
            isGetRestaurant = false;
            this.banners = [];
            this.loading = false;
            this.$emit("getRestaurantData", isGetRestaurant);
          } else {
            this.$emit("getRestaurantData", false);
            this.banners = [];
            this.loading = false;
          }
        });
      }
    },

    // getBannerCategoryId(id){
    //   this.$emit("setSingleRestaurantId", id);
    // }
  },
};
</script>
